/**
 * Quote Form — FINAL WORKING VERSION
 * + Exit-intent popup when user tries to leave after Step 1 but before Step 2 is done
 */

(function () {

  console.log("Quote form loaded");

  const API_URL             = 'https://signsincv2.codeblue.agency/api/submit/new-signsinc';
  // const API_URL             = 'https://signsincv2.codeblue.agency/api/submit/form';
  const UPLOAD_URL          = 'https://imagescloudv2.codeblue.agency/api/image/upload';
  const ALT_CONTACT_URL     = 'https://signsincv2.codeblue.agency/api/update/contact-alternative';
  const SESSION_KEY         = 'signsinc_session';

  let quoteUuid        = null;
  let airtableRecordId = null;
  let uploadedImageUrl = '';
  let allUploadedUrls  = []; // append-only across all batches/steps — never shrinks
  let isUploading      = false;
  let imageSelected    = false;

  // Exit-intent state
  let allowLeave     = false; // flipped true only when user clicks "Leave anyway"
  let formDone       = false; // flipped true after successUI() — nothing to intercept anymore
  let step1Submitted = false; // flipped true after step1 API call succeeds

  /* ---------------- SAFE GLOBALS ---------------- */

  window.placement = window.placement || '';

  // Exposed so the prospect-sync block below (separate IIFE) can read the
  // same uploaded-image list without duplicating the upload logic.
  window.getAllUploadedImageUrls = function () {
    return allUploadedUrls.slice();
  };

  /* ---------------- UUID ---------------- */

  function uuid() {
    return crypto.randomUUID
      ? crypto.randomUUID()
      : 'xxxxxx-4xxx-yxxx'.replace(/[xy]/g, c => {
          const r = Math.random() * 16 | 0;
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
  }

  /* ---------------- HELPERS ---------------- */

  const val = id => document.getElementById(id)?.value.trim() || '';

  function getName() { return val('f-name'); }

  function getSignTypes() {
    return [...document.querySelectorAll('.mc.sel')]
      .map(e => e.dataset.type)
      .filter(Boolean);
  }

  function getLightingOptions() {
    return [...document.querySelectorAll('.lighting-opt.sel')]
      .map(e => e.dataset.value)
      .filter(Boolean);
  }

  function getSignMaterial() {
    return [...document.querySelectorAll('.material-opt.sel')]
      .map(e => e.dataset.value)
      .filter(Boolean);
  }

  window.toggleOption = function (el) {
    el.classList.toggle('sel');
  };

  /* ---------------- ERROR HELPERS ---------------- */

  function showFieldErr(id) {
    const el = document.getElementById(id);
    if (el) el.classList.add('show');
  }

  function hideFieldErr(id) {
    const el = document.getElementById(id);
    if (el) el.classList.remove('show');
  }

  /* ---------------- SESSION (localStorage) ---------------- */

  function saveSession() {
    const session = {
      quoteUuid,
      airtableRecordId,
      name:      val('f-name'),
      email:     val('f-email'),
      phone:     val('f-phone'),
      website:   val('f-web'),
      placement: window.placement,
    };
    try {
      (window.safeLocalStorage||localStorage).setItem(SESSION_KEY, JSON.stringify(session));
    } catch (e) {
      console.warn('Could not save session:', e);
    }
  }

  function clearSession() {
    try {
      (window.safeLocalStorage||localStorage).removeItem(SESSION_KEY);
    } catch (e) {}
  }

  function loadSession() {
    try {
      const raw = (window.safeLocalStorage||localStorage).getItem(SESSION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  /* ---------------- RESTORE SESSION ON PAGE LOAD ---------------- */

  function restoreSession() {
    const session = loadSession();
    if (!session || !session.quoteUuid) return;

    quoteUuid        = session.quoteUuid;
    airtableRecordId = session.airtableRecordId;
    step1Submitted   = true;

    const setField = (id, value) => {
      const el = document.getElementById(id);
      if (el && value) el.value = value;
    };
    setField('f-name',  session.name);
    setField('f-email', session.email);
    setField('f-phone', session.phone);
    setField('f-web',   session.website);

    if (session.placement) {
      window.placement = session.placement;
      const selectedPlacements = session.placement.split(',').map(s => s.trim()).filter(Boolean);
      ['indoor', 'outdoor'].forEach(v => {
        const btn = document.getElementById('pl-' + v);
        if (btn) btn.classList.toggle('active', selectedPlacements.includes(v));
      });
    }

    const fstep1 = document.getElementById('fstep1');
    const fstep2 = document.getElementById('fstep2');
    const sp1    = document.getElementById('sp1');
    const sp2    = document.getElementById('sp2');
    const fcb    = document.getElementById('form-callbar');

    if (fstep1) fstep1.classList.remove('active');
    if (fstep2) fstep2.classList.add('active');
    if (sp1) { sp1.classList.remove('active'); sp1.classList.add('done'); sp1.textContent = '✓ Contact'; }
    if (sp2) sp2.classList.add('active');
    if (fcb) fcb.style.display = 'none';

    console.log('Session restored — jumped to step 2');
  }

  /* ---------------- STEP 1 — CREATE ---------------- */

  async function step1(id) {

    const current_page_url = new URL(window.location.href);
    const currentDate = new Date();
    const webUrl = val('f-web');
    const combinedImageUrl = [uploadedImageUrl, webUrl].filter(Boolean).join(',');

    const payload = {
      uuid:               id,
      name:               getName(),
      email:              val('f-email'),
      phone:              val('f-phone'),
      business_website:   webUrl,
      details:            val('f-details'),
      lead_page_url:      window.location.href,
      first_click:        (window.safeLocalStorage||localStorage).getItem('first_click'),
      first_visit:        (window.safeLocalStorage||localStorage).getItem('first_visit'),
      event_source:       (window.safeLocalStorage||localStorage).getItem('event_keys_data'),
      Created_at:         currentDate.toISOString(),
      leadSource:         (window.safeSessionStorage||sessionStorage).getItem('currentURL') || '',
      current_page_param: current_page_url.pathname.split('/').pop(),
      location:           (window.safeLocalStorage||localStorage).getItem('locationxh'),
      submission_step:    "S1 Submitted",
      image_url:          combinedImageUrl,
    };

    const res = await fetch(API_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify(payload)
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Step 1 failed');

    return {
      uuid:             data.data?.uuid || id,
      airtableRecordId: data.airtableRecordId?.id || null
    };
  }

  /* ---------------- STEP 1 — CONTACT UPDATE (user came back) ---------------- */

  async function step1ContactUpdate() {

    const webUrl          = val('f-web');
    const combinedImgUrl  = [uploadedImageUrl, webUrl].filter(Boolean).join(',');

    const payload = {
      uuid:             quoteUuid,
      airtableRecordId: airtableRecordId,
      name:             getName(),
      email:            val('f-email'),
      phone:            val('f-phone'),
      business_website: webUrl,
      details:          val('f-details'),
      image_url:        combinedImgUrl,
    };

    const res = await fetch(API_URL, {
      method:  'PUT',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify(payload)
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Contact update failed');

    saveSession();

    return data;
  }

  /* ---------------- IMAGE UPLOAD ---------------- */

  async function uploadAll(files, name, id, onProgress) {

    const fd = new FormData();
    fd.append('name',     name);
    fd.append('page_url', window.location.href);
    fd.append('uuid',     id);

    [...files].forEach(file => fd.append('images[]', file));

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', function (e) {
        if (e.lengthComputable && onProgress) {
          const pct = Math.round((e.loaded / e.total) * 100);
          onProgress(pct);
        }
      });

      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const data = JSON.parse(xhr.responseText);
            resolve((data.imageUrls || []).join(','));
          } catch (e) {
            reject(new Error('Invalid response from upload server'));
          }
        } else {
          reject(new Error('Image upload failed'));
        }
      });

      xhr.addEventListener('error', () => reject(new Error('Image upload failed')));
      xhr.addEventListener('abort', () => reject(new Error('Image upload aborted')));

      xhr.open('POST', UPLOAD_URL);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send(fd);
    });
  }

  // Upload a single file. Used by the per-chip flow so each chip animates independently.
  function uploadOne(file, name, id, onProgress) {
    const fd = new FormData();
    fd.append('name',     name);
    fd.append('page_url', window.location.href);
    fd.append('uuid',     id);
    fd.append('images[]', file);

    const xhr = new XMLHttpRequest();
    const promise = new Promise((resolve, reject) => {
      xhr.upload.addEventListener('progress', function (e) {
        if (e.lengthComputable && onProgress) {
          const pct = Math.round((e.loaded / e.total) * 100);
          onProgress(pct);
        }
      });
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const data = JSON.parse(xhr.responseText);
            const urls = data.imageUrls || [];
            resolve(urls[0] || urls.join(','));
          } catch (e) {
            reject(new Error('Invalid response from upload server'));
          }
        } else {
          reject(new Error('Image upload failed'));
        }
      });
      xhr.addEventListener('error', () => reject(new Error('Image upload failed')));
      xhr.addEventListener('abort', () => reject(new Error('Image upload aborted')));
      xhr.open('POST', UPLOAD_URL);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send(fd);
    });
    return { promise, xhr };
  }

  /* ---------------- FILE CHANGE HANDLER ---------------- */

  window.handleFileChange = async function (input) {

    const files = input?.files;
    if (!files || !files.length) return;

    imageSelected = true;
    hideFieldErr('e-upload');

    if (!quoteUuid) {
      console.warn('No quoteUuid yet, skipping upload');
      return;
    }

    // Grab the last N chips in the container, where N = files.length.
    const container  = document.getElementById('file-previews');
    const allChips   = container ? [...container.querySelectorAll('.upload-chip')] : [];
    const batchChips = allChips.slice(-files.length);

    const chips = batchChips.map(chip => ({
      el:     chip,
      fill:   chip.querySelector('.upload-chip-bar-fill'),
      status: chip.querySelector('.upload-chip-status'),
      xBtn:   chip.querySelector('.upload-chip-x')
    }));

    // Recompute global state from ALL chips currently in DOM.
    // Each chip stores its upload URL in data-upload-url once done,
    // so this works correctly across multiple batches and after chips are removed.
    function recomputeGlobal() {
      if (!container) return;
      var allNow     = [...container.querySelectorAll('.upload-chip')];
      var anyPending = allNow.some(function(c) { return c.dataset.uploadPending === '1'; });
      isUploading   = anyPending;
      // imageSelected: true if any upload ever completed OR chips are still pending
      imageSelected = allUploadedUrls.length > 0 || allNow.length > 0;
      if (anyPending) loading(true, 'Uploading...');
      else            loading(false);
      // Reset file input when all chips are gone so the same file can be re-selected
      if (allNow.length === 0) {
        var fi = document.getElementById('file-input');
        if (fi) fi.value = '';
      }
      // Clear upload error if we have any uploaded images, pending chips, or a URL typed
      if (imageSelected || val('f-web')) hideFieldErr('e-upload');
    }

    // Mark this batch's chips as pending
    batchChips.forEach(function(chip) { chip.dataset.uploadPending = '1'; });

    isUploading = true;
    loading(true, 'Uploading...');

    console.log('Uploading', files.length, 'image(s)...');

    [...files].forEach(function(file, i) {
      var chip = chips[i];
      var handle;
      var aborted = false;

      if (chip && chip.xBtn) {
        var origOnClick = chip.xBtn.onclick;
        chip.xBtn.onclick = function () {
          aborted = true;
          if (handle && handle.xhr) { try { handle.xhr.abort(); } catch(e) {} }
          chip.el.dataset.uploadPending = '0';
          if (origOnClick) origOnClick.call(this); // removes chip from DOM
          // Defer so DOM removal completes before we query remaining chips
          setTimeout(recomputeGlobal, 0);
        };
      }

      handle = uploadOne(file, getName(), quoteUuid, function (pct) {
        if (aborted) return;
        if (chip && chip.fill)   chip.fill.style.width   = pct + '%';
        if (chip && chip.status) chip.status.textContent = pct + '%';
      });

      handle.promise.then(function (url) {
        if (aborted) return;
        if (chip) {
          chip.el.dataset.uploadPending = '0';
          if (chip.fill)   { chip.fill.style.width = '100%'; chip.fill.classList.add('done'); }
          if (chip.status) { chip.status.classList.remove('uploading'); chip.status.classList.add('done'); chip.status.textContent = '✓ Done'; }
        }
        // Accumulate — never removed even if user deletes the chip or goes back
        allUploadedUrls.push(url);
        uploadedImageUrl = allUploadedUrls.join(',');
        console.log('File uploaded:', file.name, '→', url, '| all:', uploadedImageUrl);
        recomputeGlobal();
        if (typeof window.__prospectImagesUpdated === 'function') window.__prospectImagesUpdated();
      }).catch(function (e) {
        if (aborted) return;
        if (chip) {
          chip.el.dataset.uploadPending = '0';
          if (chip.fill)   chip.fill.style.width = '0%';
          if (chip.status) { chip.status.classList.remove('uploading'); chip.status.textContent = 'Failed'; chip.status.style.color = '#C0392B'; }
        }
        console.error('Upload failed (' + file.name + '):', e.message);
        showFieldErr('e-upload');
        recomputeGlobal();
      });
    });
  };

  /* ---------------- STEP 2 ---------------- */

  async function step2(uuid, imageUrl, airtableRecordId) {

    const lightingOptions = getLightingOptions();
    const signMaterial    = getSignMaterial();

    const LIGHTING_LABELS = {
      frontlit:     'Front-Lit',
      backlit:      'Back-Lit',
      frontbacklit: 'Front & Back Lit',
      nolighting:   'No Lighting',
    };

    const MATERIAL_LABELS = {
      acrylic: 'Acrylic',
      metal:   'Metal',
      notsure: 'Not Sure',
    };

    const payload = {
      uuid,
      airtableRecordId,
      image_url:               imageUrl,
      sign_placement:          window.placement,
      lighting_options:        lightingOptions,
      lighting_options_string: lightingOptions.map(t => LIGHTING_LABELS[t] || t).join(', '),
      sign_material:           signMaterial,
      sign_material_string:    signMaterial.map(m => MATERIAL_LABELS[m] || m).join(', '),
      estimated_size:          val('f-estimated-size'),
      submission_step:         "S2 Completed",
    };

    const res = await fetch(API_URL, {
      method:  'PATCH',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify(payload)
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || 'Step 2 failed');

    return data;
  }

  /* ---------------- ALTERNATIVE CONTACT UPDATE ---------------- */

  window.updateAlternativeContact = async function (field) {

    if (!quoteUuid) {
      console.warn('updateAlternativeContact: no quoteUuid');
      return;
    }

    const emailEl  = document.getElementById('ty-email-input');
    const phoneEl  = document.getElementById('ty-phone-input');

    const btnId    = field === 'email' ? 'btn-update-email' : 'btn-update-phone';
    const statusId = field === 'email' ? 'update-email-status' : 'update-phone-status';
    const btn      = document.getElementById(btnId);
    const statusEl = document.getElementById(statusId);

    if (btn) { btn.disabled = true; btn.textContent = 'Saving...'; }
    if (statusEl) { statusEl.textContent = ''; statusEl.className = 'alt-contact-status'; }

    const payload = { uuid: quoteUuid };

    if (field === 'email') {
      payload.alternative_email = emailEl ? emailEl.value.trim() : '';
    } else {
      payload.alternative_phone = phoneEl ? phoneEl.value.trim() : '';
    }

    try {
      const res = await fetch(ALT_CONTACT_URL, {
        method:  'PATCH',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body:    JSON.stringify(payload)
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'Update failed');

      console.log('Alternative contact updated:', field, payload);

      if (statusEl) { statusEl.textContent = '✓ Saved'; statusEl.classList.add('success'); }
      if (btn) btn.style.display = 'none';

    } catch (e) {
      console.error('Alternative contact update failed:', e.message);

      if (statusEl) { statusEl.textContent = '✗ ' + e.message; statusEl.classList.add('error'); }
      if (btn) { btn.disabled = false; btn.textContent = 'Update'; }
    }
  };

  function initAlternativeContactListeners() {
    const fields = [
      { inputId: 'ty-email-input', btnId: 'btn-update-email', statusId: 'update-email-status', field: 'email' },
      { inputId: 'ty-phone-input', btnId: 'btn-update-phone', statusId: 'update-phone-status', field: 'phone' },
    ];

    fields.forEach(({ inputId, btnId, statusId, field }) => {
      const input    = document.getElementById(inputId);
      const btn      = document.getElementById(btnId);
      const statusEl = document.getElementById(statusId);

      if (!input || !btn) return;

      let currentValue = input.value.trim();

      input.addEventListener('input', function () {
        const changed = this.value.trim() !== currentValue;
        btn.style.display = changed ? 'inline-block' : 'none';
        if (statusEl) { statusEl.textContent = ''; statusEl.className = 'alt-contact-status'; }
      });

      btn.style.display = 'none';

      btn.onclick = async function () {
        btn.disabled = true;
        btn.textContent = 'Saving...';
        if (statusEl) { statusEl.textContent = ''; statusEl.className = 'alt-contact-status'; }

        const payload = { uuid: quoteUuid };
        if (field === 'email') payload.alternative_email = input.value.trim();
        else payload.alternative_phone = input.value.trim();

        try {
          const res = await fetch(ALT_CONTACT_URL, {
            method:  'PATCH',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body:    JSON.stringify(payload)
          });

          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data.message || 'Update failed');

          currentValue = input.value.trim();

          if (statusEl) { statusEl.textContent = '✓ Saved'; statusEl.classList.add('success'); }
          btn.style.display = 'none';
          btn.disabled = false;
          btn.textContent = 'Update';

        } catch (e) {
          if (statusEl) { statusEl.textContent = '✗ ' + e.message; statusEl.classList.add('error'); }
          btn.disabled = false;
          btn.textContent = 'Update';
        }
      };
    });
  }

  /* ---------------- EXIT INTENT POPUP ---------------- */

  // Only intercept when Step 1 is done but Step 2 is not yet submitted
  function shouldIntercept() {
    return quoteUuid && !formDone;
  }

  function showExitPopup() {
    const overlay = document.getElementById('exit-intent-overlay');
    if (overlay) overlay.style.display = 'flex';
  }

  function hideExitPopup() {
    const overlay = document.getElementById('exit-intent-overlay');
    if (overlay) overlay.style.display = 'none';
    allowLeave = false;
  }

  function injectExitPopup() {
    if (document.getElementById('exit-intent-overlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'exit-intent-overlay';
    overlay.style.cssText = [
      'display:none',
      'position:fixed',
      'inset:0',
      'z-index:99999',
      'background:rgba(0,0,0,0.58)',
      'align-items:center',
      'justify-content:center',
      'padding:1rem',
    ].join(';');

    overlay.innerHTML = `
      <div style="
        background:#fff;
        border-radius:16px;
        padding:2.2rem 2rem 1.75rem;
        max-width:420px;
        width:100%;
        border:1px solid rgba(0,0,0,0.1);
        box-shadow:0 24px 64px rgba(0,0,0,0.28);
        text-align:center;
      ">
        <div style="
          width:56px;height:56px;border-radius:50%;
          background:#FFF3CD;border:2px solid #F4A61D;
          display:flex;align-items:center;justify-content:center;
          margin:0 auto 1.25rem;
        ">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
            stroke="#F4A61D" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>

        <p style="
          font-family:'Poppins',sans-serif;
          font-size:15px;
          color:#333;
          line-height:1.7;
          margin:0 0 1.75rem;
          padding:0 0.25rem;
        ">
          It seems like there is some additional information required for an accurate
          <strong style="color:#111;font-weight:700;">price quote</strong>
          and
          <strong style="color:#111;font-weight:700;">mockup</strong>
          of your sign.
        </p>

        <button id="exit-popup-stay" style="
          width:100%;padding:14px;border-radius:8px;
          background:#0188CC;border:none;color:#fff;
          font-family:'Bebas Neue',sans-serif;
          font-size:15px;letter-spacing:.1em;text-transform:uppercase;
          cursor:pointer;margin-bottom:10px;
          transition:background .18s;
        ">Provide Missing Information</button>

        <button id="exit-popup-leave" style="
          width:100%;padding:12px;border-radius:8px;
          background:transparent;border:1px solid #ddd;
          color:#999;font-family:'Poppins',sans-serif;font-size:13px;
          cursor:pointer;transition:color .18s,border-color .18s;
        ">Leave Anyways</button>
      </div>
    `;

    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) hideExitPopup();
    });

    document.getElementById('exit-popup-stay').addEventListener('click', function () {
      hideExitPopup();
      const form = document.getElementById('q-form-wrap');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    document.getElementById('exit-popup-leave').addEventListener('click', function () {
      hideExitPopup();
      allowLeave = true;
      window.history.go(-2);
    });
  }
  function initExitGuard() {

    // 1. Tab close / address-bar URL change — native browser dialog
    window.addEventListener('beforeunload', function (e) {
      if (!shouldIntercept() || allowLeave) return;
      e.preventDefault();
      e.returnValue = ''; // required for Chrome to show the dialog
    });

    // 2. Browser back button — custom popup
    // Push a dummy state so the back button is interceptable
    if (window.history && window.history.pushState) {
      window.history.pushState({ exitGuard: true }, '');

      window.addEventListener('popstate', function () {
        if (!shouldIntercept() || allowLeave) return;
        // Re-push so the guard stays active for repeated back attempts
        window.history.pushState({ exitGuard: true }, '');
        showExitPopup();
      });
    }
  }

  /* ---------------- UI ---------------- */

  function nextUI() {
    document.getElementById('fstep1')?.classList.remove('active');
    document.getElementById('fstep2')?.classList.add('active');

    const sp1 = document.getElementById('sp1');
    const sp2 = document.getElementById('sp2');
    if (sp1) { sp1.classList.remove('active'); sp1.classList.add('done'); sp1.textContent = '✓ Contact'; }
    if (sp2) sp2.classList.add('active');

    const fcb = document.getElementById('form-callbar');
    if (fcb) fcb.style.display = 'none';

    populateStep2ContactSummary();
  }

  function populateStep2ContactSummary() {
    const name  = val('f-name');
    const email = val('f-email');
    const phone = val('f-phone');
    const nOut  = document.getElementById('fstep2-name-out');
    const eOut  = document.getElementById('fstep2-email-out');
    const pOut  = document.getElementById('fstep2-phone-out');
    const wrap  = document.getElementById('fstep2ContactSummary');
    if (nOut) nOut.textContent = name  || '—';
    if (eOut) eOut.textContent = email || '—';
    if (pOut) pOut.textContent = phone || '—';
    if (wrap) wrap.style.display = (name || email || phone) ? '' : 'none';
  }

  function successUI() {
    // Mark form as fully done — exit guard disables itself
    formDone = true;

    const name  = val('f-name');
    const email = val('f-email');
    const phone = val('f-phone');

    const tyName  = document.getElementById('ty-name-input');
    const tyEmail = document.getElementById('ty-email-input');
    const tyPhone = document.getElementById('ty-phone-input');

    if (tyName)  tyName.value  = name;
    if (tyEmail) tyEmail.value = email;
    if (tyPhone) tyPhone.value = phone;

    initAlternativeContactListeners();

    clearSession();

    document.getElementById('q-form-wrap').style.display = 'none';
    document.getElementById('q-success').style.display   = 'block';
  }

  /* ---------------- BUTTON LOADING ---------------- */

  function loading(state, label) {
    const btn = document.getElementById('btn-submit');
    if (!btn) return;
    btn.disabled = state;
    if (state) {
      btn.innerHTML = '<span class="ls"></span> ' + (label || 'Submitting...');
    } else {
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2L11 13"/><path d="M22 2L15 22 11 13 2 9l20-7z"/></svg><span style="letter-spacing:2px;">Get My Free Mockup</span>';
    }
  }

  function loadingNext(state) {
    const btn = document.getElementById('btn-next');
    if (!btn) return;
    btn.disabled = state;
    if (state) {
      const loadingText = quoteUuid ? 'Updating...' : 'Please wait...';
      btn.innerHTML = '<span class="ls"></span> ' + loadingText;
    } else {
      btn.innerHTML = '<span id="btn-next-label" style="letter-spacing:2px;">Continue to Sign Details</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    }
  }

  /* ---------------- NEXT STEP (step 1) ---------------- */

  window.nextStep = async function () {

    ['e-name', 'e-email', 'e-phone'].forEach(hideFieldErr);
    ['f-name', 'f-email', 'f-phone'].forEach(id => {
      document.getElementById(id)?.classList.remove('err');
    });

    const name  = val('f-name');
    const email = val('f-email');
    const phone = val('f-phone');

    let valid = true;

    if (!name) {
      showFieldErr('e-name');
      document.getElementById('f-name')?.classList.add('err');
      valid = false;
    }

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      showFieldErr('e-email');
      document.getElementById('f-email')?.classList.add('err');
      valid = false;
    }

    if (!phone || phone.replace(/\D/g, '').length < 7) {
      showFieldErr('e-phone');
      document.getElementById('f-phone')?.classList.add('err');
      valid = false;
    }

    if (!imageSelected && !val('f-web')) {
      showFieldErr('e-upload');
      valid = false;
    }

    if (!valid) return;

    if (step1Submitted) {
      loadingNext(true);
      try {
        nextUI();
        if (isUploading) await waitForUpload();
        await step1ContactUpdate();
      } catch (e) {
        const ePhone = document.getElementById('e-phone');
        if (ePhone) {
          ePhone.dataset.defaultText = ePhone.dataset.defaultText || ePhone.textContent;
          ePhone.textContent = e.message;
          ePhone.classList.add('show');
          const phoneInput = document.getElementById('f-phone');
          if (phoneInput) {
            phoneInput.addEventListener('input', function restore() {
              ePhone.textContent = ePhone.dataset.defaultText || 'Please enter a valid phone number';
              phoneInput.removeEventListener('input', restore);
            });
          }
        }
      }
      loadingNext(false);
      return;
    }

    loadingNext(true);

    try {
      nextUI();
      if (isUploading) {
        loadingNext(true);
        await waitForUpload();
      }
      const result     = await step1(quoteUuid);
      quoteUuid        = result.uuid;
      airtableRecordId = result.airtableRecordId;
      step1Submitted   = true;

      saveSession();

      const newUrl = window.location.pathname + '?thanks-for-response';
      window.history.pushState({}, '', newUrl);
      try {
        if (typeof gtag_report_conversion === 'function') {
          gtag_report_conversion();
        }
      } catch (error) {
        console.error('Error during gtag_report_conversion:', error);
      }

    } catch (e) {
      // Step 1 API failed. Keep the user on step 2 (contact strip is already
      // populated + Clarity-unmasked so their details are captured). Silently
      // switch URL param so the eventual submit lands on the error param path.
      console.error('Step 1 failed:', e);
      const newUrl = window.location.pathname + '?thanks-for-submission';
      window.history.pushState({}, '', newUrl);
      if (typeof window.logClientError === 'function') {
        window.logClientError('new_form_step1', e, quoteUuid);
      }
    }

    loadingNext(false);
  };

  /* ---------------- WAIT FOR UPLOAD ---------------- */

  function waitForUpload() {
    return new Promise(resolve => {
      if (!isUploading) { resolve(); return; }
      const check = setInterval(() => {
        if (!isUploading) { clearInterval(check); resolve(); }
      }, 250);
    });
  }

  /* ---------------- HANDLE SUBMIT (step 2) ---------------- */

  window.handleSubmit = async function () {

    hideFieldErr('e-placement');
    hideFieldErr('e-lighting');
    hideFieldErr('e-material');

    let valid = true;

    if (!window.placement) {
      showFieldErr('e-placement');
      valid = false;
    }

    if (getLightingOptions().length === 0) {
      showFieldErr('e-lighting');
      valid = false;
    }

    if (getSignMaterial().length === 0) {
      showFieldErr('e-material');
      valid = false;
    }

    if (!valid) return;

    if (isUploading) {
      loading(true, 'Uploading...');
      await waitForUpload();
    }

    loading(true);

    // If step 1 never succeeded (no quoteUuid), skip the step 2 API call entirely
    // — the contact details are already captured on the step 2 view via Clarity —
    // and route straight to the success screen with the error param.
    if (!quoteUuid || !step1Submitted) {
      const newUrl = window.location.pathname + '?thanks-for-submission';
      window.history.pushState({}, '', newUrl);
      if (typeof window.logClientError === 'function') {
        window.logClientError('new_form_step2_no_step1', new Error('step2 submitted without a successful step1'), quoteUuid);
      }
      successUI();
      loading(false);
      return;
    }

    try {
      await step2(quoteUuid, uploadedImageUrl, airtableRecordId);
      successUI();
    } catch (e) {
      console.error('Step 2 failed:', e);
      const newUrl = window.location.pathname + '?thanks-for-submission';
      window.history.pushState({}, '', newUrl);
      if (typeof window.logClientError === 'function') {
        window.logClientError('new_form_step2', e, quoteUuid);
      }
      successUI();
    }

    loading(false);
  };

  /* ---------------- RESET ---------------- */

  window._resetFormApi = function () {
    quoteUuid        = uuid();
    airtableRecordId = null;
    uploadedImageUrl = '';
    allUploadedUrls  = [];
    isUploading      = false;
    imageSelected    = false;
    allowLeave       = false;
    formDone         = false;
    step1Submitted   = false;
    clearSession();
    hideFieldErr('e-mockup');
    hideFieldErr('e-upload');
  };

  /* ---------------- INIT ---------------- */

  function init() {
    restoreSession(); // may set quoteUuid + step1Submitted from saved session
    if (!quoteUuid) {
      quoteUuid = uuid(); // pre-generate so uploads in step 1 can start immediately
    }
    injectExitPopup();
    initExitGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* ====================================================================
   PROSPECT LEAD — on-blur partial save (audit trail)
   Independent of main form flow's own API. First save POSTs a new
   /api/prospects record; every save after that PATCHes the same uuid.
   Survives page unload via fetch keepalive.
   ==================================================================== */
(function () {

  const PROSPECTS_API_URL    = 'https://submissions.signs.inc/api/prospects';
  const PROSPECT_UUID_KEY    = 'signsinc_prospect_uuid';
  const PROSPECT_CREATED_KEY = 'signsinc_prospect_created';

  let prospectUuid      = null;
  let prospectCreated   = false;
  let saveChain         = Promise.resolve(); // serializes requests so the POST always lands before any PATCH
  const lastSavedValues = {};

  const SIGN_TYPE_LABELS = {
    halo:        'Halo Lit',
    lightbox:    'Lightbox',
    facelit:     'Face Lit',
    flatcut:     'Flat Cut',
    fabricated:  'Fabricated',
    pushthrough: 'Push Through',
  };

  const LIGHTING_LABELS = {
    frontlit:     'Front-Lit',
    backlit:      'Back-Lit',
    frontbacklit: 'Front & Back Lit',
    nolighting:   'No Lighting',
  };

  const MATERIAL_LABELS = {
    acrylic: 'Acrylic',
    metal:   'Metal',
    notsure: 'Not Sure',
  };

  /* ---------------- UUID ---------------- */

  function uuid() {
    return crypto.randomUUID
      ? crypto.randomUUID()
      : 'xxxxxx-4xxx-yxxx'.replace(/[xy]/g, c => {
          const r = Math.random() * 16 | 0;
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
  }

  function getProspectUuid() {
    if (prospectUuid) return prospectUuid;
    try {
      prospectUuid = (window.safeLocalStorage||localStorage).getItem(PROSPECT_UUID_KEY);
    } catch (e) {}
    if (!prospectUuid) {
      prospectUuid = uuid();
      try {
        (window.safeLocalStorage||localStorage).setItem(PROSPECT_UUID_KEY, prospectUuid);
      } catch (e) {}
    }
    try {
      prospectCreated = (window.safeLocalStorage||localStorage).getItem(PROSPECT_CREATED_KEY) === '1';
    } catch (e) {}
    return prospectUuid;
  }

  function markProspectCreated() {
    prospectCreated = true;
    try {
      (window.safeLocalStorage||localStorage).setItem(PROSPECT_CREATED_KEY, '1');
    } catch (e) {}
  }

  /* ---------------- HELPERS ---------------- */

  function getCurrentSignTypes() {
    return [...document.querySelectorAll('.mc.sel')]
      .map(e => e.dataset.type)
      .filter(Boolean);
  }

  function getCurrentLightingOptions() {
    return [...document.querySelectorAll('.lighting-opt.sel')]
      .map(e => e.dataset.value)
      .filter(Boolean);
  }

  function getCurrentSignMaterial() {
    return [...document.querySelectorAll('.material-opt.sel')]
      .map(e => e.dataset.value)
      .filter(Boolean);
  }

  function labelJoin(arr, labels) {
    return arr.map(v => labels[v] || v).join(', ');
  }

  /* ---------------- SAVE FUNCTION ---------------- */

  function saveProspectField(field, value) {
    // Skip if unchanged
    if (lastSavedValues[field] === value) return;

    // Skip if empty
    if (value === '' || value === null || value === undefined) return;

    // For arrays, skip if empty
    if (Array.isArray(value) && value.length === 0) return;

    lastSavedValues[field] = value;

    getProspectUuid(); // ensures prospectUuid + prospectCreated are loaded before we branch below

    const payload = {
      uuid:          prospectUuid,
      lead_page_url: window.location.href,
      lead_page:     window.location.pathname,
      location:      (window.safeLocalStorage||localStorage).getItem('locationxh') || '',
      first_click:   (window.safeLocalStorage||localStorage).getItem('first_click') || '',
      first_visit:   (window.safeLocalStorage||localStorage).getItem('first_visit') || '',
      event_source:  (window.safeLocalStorage||localStorage).getItem('event_keys_data') || '',
    };
    payload[field] = value;

    // Human-readable "_string" companions — the API prefers these when both are sent
    if (field === 'signtypes') payload.signtypes_string = labelJoin(value, SIGN_TYPE_LABELS);
    if (field === 'lighting_options') payload.lighting_options_string = labelJoin(value, LIGHTING_LABELS);
    if (field === 'sign_material') payload.sign_material_string = labelJoin(value, MATERIAL_LABELS);

    if (typeof window.getLeadTrackingData === 'function') {
      payload.tracking_metadata = window.getLeadTrackingData();
    }

    const isFirstSave = !prospectCreated;
    const method = isFirstSave ? 'POST' : 'PATCH';
    const url    = isFirstSave ? PROSPECTS_API_URL : PROSPECTS_API_URL + '/' + encodeURIComponent(prospectUuid);

    // Mark created immediately (optimistic) so a second field blurring right
    // after this one doesn't also fire as a POST and create a duplicate record.
    if (isFirstSave) markProspectCreated();

    saveChain = saveChain
      .then(() =>
        fetch(url, {
          method,
          headers:   { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:      JSON.stringify(payload),
          keepalive: true, // lets request survive page unload (tab close, navigation)
        })
      )
      .catch((e) => {
        // Silent — partial save is best-effort
        console.warn('Prospect save failed:', e.message);
      });
  }

  /* ---------------- IMAGES (hooked from the main upload flow above) ---------------- */

  window.__prospectImagesUpdated = function () {
    if (typeof window.getAllUploadedImageUrls !== 'function') return;
    saveProspectField('images', window.getAllUploadedImageUrls());
  };

  /* ---------------- LISTENERS ---------------- */

  function initProspectBlurListeners() {

    // Text inputs — fire on blur, only if value actually changed
    const textFields = [
      { id: 'f-name',           key: 'name' },
      { id: 'f-email',          key: 'email' },
      { id: 'f-phone',          key: 'phone' },
      { id: 'f-web',            key: 'business_website' },
      { id: 'f-details',        key: 'details' },
      { id: 'f-estimated-size', key: 'estimated_size' },
    ];

    textFields.forEach(({ id, key }) => {
      const el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('blur', () => {
        saveProspectField(key, el.value.trim());
      });
    });

    // Placement (Indoor / Outdoor) — fire on click
    ['pl-indoor', 'pl-outdoor'].forEach(id => {
      const btn = document.getElementById(id);
      if (!btn) return;
      btn.addEventListener('click', () => {
        // window.placement is updated by setPlacement() in the main script
        setTimeout(() => saveProspectField('sign_placement', window.placement), 0);
      });
    });

    // Sign type mockup cards — fire when toggled
    document.querySelectorAll('.mc').forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => saveProspectField('signtypes', getCurrentSignTypes()), 0);
      });
    });

    // Lighting option buttons — fire when toggled
    document.querySelectorAll('.lighting-opt').forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => saveProspectField('lighting_options', getCurrentLightingOptions()), 0);
      });
    });

    // Sign material buttons — fire when toggled
    document.querySelectorAll('.material-opt').forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => saveProspectField('sign_material', getCurrentSignMaterial()), 0);
      });
    });
  }

  /* ---------------- INIT ---------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProspectBlurListeners);
  } else {
    initProspectBlurListeners();
  }

})();